import React from 'react'
import ImageIcon from './android-icon.png'
import ImageButton from './image-button'
import hooks from '../../../hooks'
import { isAndroid } from 'react-device-detect'


const AndroidButton = () => {
    const { toLocation, endpoints } = hooks.useClientLocation()
    
    const { isAdmin, isBusy } = hooks.useCurrentUser()
    
    const onClick = React.useCallback(() => {
        toLocation(endpoints.MOBILE_ANDROID)
    }, [toLocation, endpoints])

    React.useEffect(() => {
        if (!isBusy && !isAdmin && isAndroid) {
            onClick()
        }
    }, [isAndroid, onClick, isBusy, isAdmin ])

    return (
        <ImageButton src={ImageIcon} onClick={onClick}>ANDROID</ImageButton>
    )
}

export default AndroidButton
